/* eslint-disable react-hooks/exhaustive-deps */

import { TreeBaseIcon } from '@tableau/icons/TreeBaseIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import { connect } from 'react-redux';
import { style } from 'typestyle';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { MapStateToProps } from '~src/commonInfra/utils/ConnectUtils';
import { Redux } from '~src/settings/general-settings/utils';
import { selectLayoutType } from '~src/spacesPlatform/selectors/LayoutTypeSelector';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

import { Messages } from '../../codegen/Localize';
import { ProjectTreeService } from '../services/ProjectTreeService';

type ProjectTreeToggleProps = {
    spaceInfo: SpaceInfo;
};

const iconSize = 24;

export function ProjectTreeToggle(props: ProjectTreeToggleProps): JSX.Element {
    const enabled = ProjectTreeService.instance.isProjectTreeEnabled(props.spaceInfo);
    const [projectTreeToggleState, setProjectTreeToggleState] = React.useState(ProjectTreeService.instance.toggleState);
    const layout = Redux.useSelector(selectLayoutType);

    React.useEffect(() => {
        if (enabled) {
            ProjectTreeService.instance.onProjectTreeToggleStateChanged.push(toggleState => {
                setProjectTreeToggleState(toggleState);
            });

            setProjectTreeToggleState(ProjectTreeService.instance.toggleState);
            ProjectTreeService.instance.sendProjectTreeToggleUsageTelemetryEvent('impression');
        }
    }, [enabled]);

    return enabled && layout === 'desktop' ? <div className={toggleContainerStyle}>
        <ButtonWidget
            aria-label={Messages.exploreProjectTreeToggleText()}
            buttonType={ButtonType.Icon}
            className={toggleButtonStyle}
            onClick={() => ProjectTreeService.instance.toggle()}
            aria-expanded={projectTreeToggleState === 'on'}
            title={Messages.exploreProjectTreeToggleText()}>
            <TreeBaseIcon size={iconSize} />
        </ButtonWidget>
    </div>
        : null;
}

const mapStateToProps: MapStateToProps<ProjectTreeToggleProps> = (state: AppState) => ({
    spaceInfo: selectSpaceInfo(state),
    layout: selectLayoutType(state),
});

export const ConnectedProjectTreeToggle: React.ComponentClass<{}> = connect(mapStateToProps)(ProjectTreeToggle);

export const toggleContainerStyle = style({
    position: 'relative',
    width: 32,
    marginRight: 8
});

const toggleButtonStyle = style({
    position: 'absolute',
    transform: 'translate(0,-50%)',
    border: 'none',
    background: 'none',
    padding: 0,
    minWidth: 'auto',
    width: iconSize + 4,
    height: iconSize + 4,
});

